import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "@chakra-ui/react";
import { ContentCardBackdrop } from "../../cards/components/ContentCardBackdrop";
import { SectionHeader } from "../../../screens/reader/components/shared/SectionHeader";
import { User } from "../../../types";
import { useSlideInMenu } from "../hooks/useSlideInMenu";
import { SLIDE_IN_MENUS } from "../../../screens/root/constants";

export interface MyPagesListProps {
  user: User;
}

export function MyPagesList({ user }: MyPagesListProps) {
  return (
    <Flex flexDirection="column" gap="16px" width="full">
      <SectionHeader text="My Pages" />
      <Flex flexDirection="column" gap="8px" width="full">
        {user.artist_users.map((page) => (
          <PagesCard
            key={page.id}
            imageUrl={page.artist.avatar_url}
            name={page.artist.roman_name}
            type={page.artist.artist_type.name}
            artistId={page.artist_id}
          />
        ))}
      </Flex>
    </Flex>
  );
}

interface PagesCardProps {
  imageUrl: string;
  name: string;
  type: string;
  artistId: number;
}

export function PagesCard({ imageUrl, name, type, artistId }: PagesCardProps) {
  const { onToggleSlideInMenu } = useSlideInMenu();

  return (
    <Link
      onClick={() =>
        onToggleSlideInMenu(SLIDE_IN_MENUS.publisher, { artistId })
      }
    >
      <Flex
        height="72px"
        width="full"
        direction="row"
        position="relative"
        alignItems="center"
        justifyContent="start"
        gap=".5rem"
        _hover={{
          "& .card-img-wrapper": {
            transform: "translateY(-2px)",
          },
        }}
        transition="all 0.2s ease"
      >
        <ContentCardBackdrop
          position="absolute"
          bottom={0}
          width="calc(100% - 8px)"
          left={2}
        />
        <Box position="relative">
          <Image
            className="card-img-wrapper"
            loading="lazy"
            src={imageUrl}
            w="3.5rem"
            minW="3.5rem"
            borderRadius="14px"
            alt={`Avatar for ${name}`}
            transition="transform 0.2s ease"
          />
        </Box>
        <Flex
          direction="column"
          position="relative"
          pr={3}
          width="100%"
          minWidth={0}
          gap=".25rem"
        >
          <Text variant="cardSubtitle" noOfLines={1}>
            {name}
          </Text>
          <Text variant="cardVitals" color="neutral.200">
            {type}
          </Text>
        </Flex>
      </Flex>
    </Link>
  );
}
